<template>
  <div>
    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      transition="scale-transition"
      location="bottom"
      min-width="auto"
    >
      <template v-slot:activator="{ props }">
        <v-text-field
          :model-value="modelValue"  :label="label"
          prepend-inner-icon="mdi-calendar"
          readonly
          v-bind="props"
          variant="outlined"
          density="compact"
          hide-details
          color="primary"
        ></v-text-field>
      </template>

      <v-locale-provider locale="ja">
        <v-card elevation="4" class="d-inline-block rounded-lg" style="max-width: 328px;">
          <v-date-picker
            v-model="internalDate"
            hide-header
            color="primary"
            elevation="0" 
          ></v-date-picker>
        </v-card>
      </v-locale-provider>
    </v-menu>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "DatePicker",

  props: {
    label: {
      type: String,
      default: "",
    },
    // Vue 3 の v-model の標準プロパティは「modelValue」
    modelValue: {
      type: [String, null],
      default: "",
    },
  },

  //  どのイベントを発火させるかを明示する
  emits: ["update:modelValue"],

  data() {
    return {
      menu: false,
    };
  },

  computed: {
    // 親の「文字列(YYYY-MM-DD)」とカレンダーの「Date型」を自動で翻訳する仕組み
    internalDate: {
      get(): Date | undefined {
        // 親から文字列が渡ってきたら、Date型に変換してカレンダーに渡す
        if (this.modelValue) {
          return new Date(this.modelValue);
        }
        return undefined;
      },
      set(val: Date | undefined) {
        if (val) {
          // カレンダーで日付が選ばれたら、「YYYY-MM-DD」の文字列に直して親に返す
          const year = val.getFullYear();
          const month = String(val.getMonth() + 1).padStart(2, "0");
          const day = String(val.getDate()).padStart(2, "0");
          const formattedDate = `${year}-${month}-${day}`;
          
          this.$emit("update:modelValue", formattedDate);
        } else {
          this.$emit("update:modelValue", "");
        }
        
        // 日付を選んだら自動でメニューを閉じる
        this.menu = false;
      },
    },
  },
});
</script>